import React, { Component } from "react";
import Card from "../components/Card";

export default class Education extends Component {
  render() {
    return (
      <React.Fragment>
        <Card id="Education" className="content" headerText="Education">
          <table>
            <thead>
              <tr>
                <th>Aston University, Birmingham</th>
                <th>Oct 2015 - Sep 2019</th>
                <th>BSC (Hons) Computing Science</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3">
                  <strong>Key Modules first year:</strong> Java programming
                  Development (56%), Internet computing (74%), Computer systems
                  Organisation (81%), Information Systems and database (89%)
                  <br />
                  <strong>Key Modules second year:</strong> Software engineering
                  (67%), Group project (79%), Programming language concepts
                  (64%)
                  <br />
                  <strong>Key Modules third year:</strong> Final Year project
                  (75%), Mobile Design and Development (77%) Birmingham
                  Metropolitan College
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <thead>
              <tr>
                <th>Birmingham Metropolitan College</th>
                <th>Sep 2013 – July 2015</th>
                <th>BTEC Level 3 Extended Diploma in computer science </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3">
                  <strong>Key modules:</strong> Event driven Programming
                  (Distinction), Object Orientated Programming (Distinction),
                  Software design and development (Distinction)
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
      </React.Fragment>
    );
  }
}
